// custom hook para solicitar los contactos

import { useState, useEffect } from "react";

// url importation
import { urls } from "../../api-urls/api-urls";

// react router dom import
import { useNavigate } from "react-router-dom";

// app config import
import { LANGUAGE } from "../../config/appConf.js";







export const useFetchCont = (idCus = "") => {

  // GET the useNavigate
  const navigate = useNavigate();

  // state definition
  const [contacts, setContacts] = useState([]);
  const [controller, setController] = useState(null); // estado para cancelar la peticion al servidor
  const [state, setState] = useState({ isLoading: false });


  // funcion para solicitar la data al servidor
  const fetchDataServ = async () => {

    const abortController = new AbortController();

    setController(abortController);

    const TOKEN = localStorage.getItem("token");

    const END_POINT = `${urls.contactCustomer}/contacts/${idCus}?lang=${LANGUAGE}`;


    if (!TOKEN) {
      return navigate("/")
    }

    try {
      setState((val) => ({ ...val, isLoading: true }));

      const response = await fetch(END_POINT, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": TOKEN
        },
        signal: abortController.signal
      });

      const data = await response.json();

      if (response.status === 200) {
        setContacts(data?.contacts);
      } else if (response.status === 401) {
        return navigate("/");
      } else if ([404, 500].includes(response.status)) {

      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (err) {
      console.error(err);
    }
  };


  // useEffect para solicitar la data al servidor
  useEffect(() => {

    fetchDataServ();

    return () => {
      if (controller) {
        controller.abort();
      }
    };

  }, []);



  return {
    state,
    contacts
  }
};